import type {OperationVariables} from 'src/internal/revamp/graphql/types';

const SEPARATOR = '___';

// The variable name follows the pattern hash___otherHash___variableName
export function extractPrefixFromVariableName(variableName: string): string {
  const segments = variableName.split(SEPARATOR);

  // This should never happen, but it'll yell at us in dev time if we mess something up with the transformation
  if (segments.length < 2) {
    throw new Error(
      `Wrong variable name pattern in transformed query variable ${variableName}`,
    );
  }

  return segments.slice(0, -1).join(SEPARATOR);
}

export function extractFragmentHashFromPrefix(prefix: string): string {
  const compositionHashSegments = prefix.split(SEPARATOR);

  return compositionHashSegments[compositionHashSegments.length - 1];
}

export function extractFragmentHashFromVariableName(
  variableName: string,
): string {
  const prefix = extractPrefixFromVariableName(variableName);

  return extractFragmentHashFromPrefix(prefix);
}

export function removePrefixFromCompositionName(variableName: string): string {
  return variableName.split(SEPARATOR).slice(-1)[0];
}

export function prefixVariables(
  vars: OperationVariables,
  prefix: string,
): OperationVariables {
  const prefixedVars: OperationVariables = {};

  for (const [key, value] of Object.entries(vars)) {
    prefixedVars[`${prefix}${SEPARATOR}${key}`] = value;
  }

  return prefixedVars;
}

export function extractFieldNameFromAlias(alias: string): string {
  return alias.split(SEPARATOR).pop()!;
}
